import { useEffect } from "react";

import { init, mainButton as mb, secondaryButton as sb, useLaunchParams } from "@telegram-apps/sdk-react";
import { useAtom } from "jotai";

import { useTranslation } from "@arc/i18n";
import { selectedLanguageAtom } from "@arc/shared/atoms/ui";

export const InitTelegramDataListener = () => {
  const { t: _t, i18n } = useTranslation();
  const lp = useLaunchParams();
  init();
  mb.mount();
  sb.mount();

  const [language, setLanguage] = useAtom(selectedLanguageAtom);

  useEffect(() => {
    mb.setParams({ isVisible: false });
    sb.setParams({ isVisible: false });
  }, []);

  useEffect(() => {
    mb.setParams({
      backgroundColor: "#07ACFF",
      textColor: "#FFFFFF",
    });
    sb.setParams({
      backgroundColor: "#07ACFF",
      textColor: "#FFFFFF",
    });
  }, []);

  useEffect(() => {
    const userLanguage = language || lp.initData?.user?.languageCode;
    if (userLanguage) {
      i18n.languages.forEach((lang) => {
        if (userLanguage === lang) {
          i18n.reloadResources([lang]).then(() => i18n.changeLanguage(lang));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!i18n.isInitialized) return;

    i18n.on("languageChanged", (lang) => {
      document.documentElement.setAttribute("lang", lang);
      setLanguage(i18n.language);
    });

    return () => {
      i18n.off("languageChanged");
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.isInitialized]);

  return null;
};
